/* ===========================================================
   pages/SignIn.jsx — your Weather Protocol account works here

   Sign in, or make an account (it's the same account on
   weatherprotocol.org). While Docs is being tested, new accounts are
   only possible for invited emails, and the server says so in plain
   words.
   =========================================================== */

import { useState } from 'preact/hooks';
import { api } from '../lib/api.js';
import { loadSession } from '../state.js';
import { Button, Icon } from '../ui/ui.jsx';
import { Proto, translate } from '../ui/proto.jsx';
import { Logo } from './DocPage.jsx';

export function SignIn() {
  const [making, setMaking] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const [forgot, setForgot] = useState(false);

  const submit = async e => {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      await api(making ? '/api/auth/signup' : '/api/auth/login', { method: 'POST', body: { email, password, name: making ? name : undefined } });
      await loadSession();
    } catch (error) {
      setErr(error);
    } finally {
      setBusy(false);
    }
  };

  const t = err && translate(err);
  return (
    <div class="signin">
      <div class="signin-card">
        <div class="signin-brand"><Logo size={36} /><span>Docs Protocol</span></div>
        <h1>{making ? 'Make your account' : 'Sign in'}</h1>
        <p class="lead">Write notes, school work and plans. Everything saves by itself, even offline.</p>
        <p class="note"><Icon name="user" size={15} /><span>Use your <strong>Weather Protocol</strong> account. It's the same one.</span></p>
        <form onSubmit={submit} class="stack">
          {making && (
            <label class="field">
              <span>Your name (shown to people you share with)</span>
              <input value={name} onInput={e => setName(e.target.value)} autocomplete="name" maxLength={40} />
            </label>
          )}
          <label class="field">
            <span>Email</span>
            <input type="email" required value={email} onInput={e => setEmail(e.target.value)} autocomplete="email" autofocus />
          </label>
          <label class="field">
            <span>Password{making ? ' (10 characters or more)' : ''}</span>
            <input type="password" required minLength={making ? 10 : undefined} value={password} onInput={e => setPassword(e.target.value)}
              autocomplete={making ? 'new-password' : 'current-password'} />
          </label>
          {t && (
            <div class="form-error" role="alert">
              <Proto size={40} fixing={t.ours} />
              <span>{t.text}</span>
            </div>
          )}
          <Button kind="primary" size="lg" type="submit" disabled={busy}>{busy ? 'One moment…' : making ? 'Make account' : 'Sign in'}</Button>
        </form>
        <div class="signin-links">
          <button type="button" class="linkish" onClick={() => { setMaking(m => !m); setErr(null); }}>
            {making ? 'I already have an account' : 'New here? Make an account'}
          </button>
          {!making && <button type="button" class="linkish" onClick={() => setForgot(f => !f)}>Forgot your password?</button>}
        </div>
        {forgot && (
          <p class="hint">Your password is the one from Weather Protocol. If you can't remember it, ask the site owner to set a new one for you (email reset links aren't switched on yet).</p>
        )}
      </div>
    </div>
  );
}
